<template>
<w-settings-content-template>
  <el-tabs slot="content" v-model="activeTab" type="card">
    <el-tab-pane label="구성정보 수집" name="AUTODISCOVERY">
      <w-schedule-table ref="autodiscoveryView" :activeTab="activeTab" :activeFlag="activeTab === 'AUTODISCOVERY'" />
    </el-tab-pane>
    <el-tab-pane label="정책감사수행" name="CMPL_CHECK">
      <w-schedule-table ref="cmplCheckView" :activeTab="activeTab" :activeFlag="activeTab === 'CMPL_CHECK'" />
    </el-tab-pane>
    <el-tab-pane label="스크립트 수행" name="EXEC_TEMPLATE">
      <w-schedule-table ref="execTemplateView" :activeTab="activeTab" :activeFlag="activeTab === 'EXEC_TEMPLATE'" />
    </el-tab-pane>
    <el-tab-pane label="정기점검" name="FAULT_CHECK">
      <w-schedule-table ref="faultCheckView" :activeTab="activeTab" :activeFlag="activeTab === 'FAULT_CHECK'" />
    </el-tab-pane>
    <el-tab-pane label="IP대역 검색" name="IP_SCAN">
      <w-schedule-table ref="ipScanView" :activeTab="activeTab" :activeFlag="activeTab === 'IP_SCAN'" />
    </el-tab-pane>
    <el-tab-pane label="연결정보 수집" name="AUTO_TOPOLOGY">
      <w-schedule-table ref="autoTopologyView" :activeTab="activeTab" :activeFlag="activeTab === 'AUTO_TOPOLOGY'" />
    </el-tab-pane>
  </el-tabs>
</w-settings-content-template>
</template>

<script>
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import camelCase from 'lodash/camelCase';
import WScheduleTable from './components/table/ScheduleTable';

export default {
  name: 'WSetting',
  components: {
    WSettingsContentTemplate,
    WScheduleTable,
  },
  data() {
    return {
      activeTab: 'AUTODISCOVERY',
    };
  },
  watch: {
    activeTab: {
      immediate: true,
      handler(tabName) {
        this.$nextTick(() => {
          this.$refs[`${camelCase(tabName)}View`].loadData();
        });
      },
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/ScheduleSettings/NetworkScheduleSettings/index.vue